import { ITopBarMenuItem } from 'components/__SHARED__/TopBar/TopBarMenuItem';
import { Toast } from 'plataforma-fundacao-componentes';
import { createContext } from 'react';

export interface ILayoutContext {
  isMobile: boolean;
  isLogged: boolean;
  refContainer: React.RefObject<any>;
  setPageMenuItems: (menuItems?: ITopBarMenuItem[]) => void;
  setToolbarReadOnly: (readOnly: boolean) => void;
  pageMenuItems: ITopBarMenuItem[];
  headerHeight: number;
  startLoading: (message?: string) => void;
  finishLoading: () => void;
  disableNavDrawer?: boolean;
  setDisableNavDrawer: (value: boolean) => void;
  showToast: (_toast: React.ComponentProps<typeof Toast>) => void;
  clearToasts: () => void;
}

export default createContext<ILayoutContext>({
  isMobile: false,
  isLogged: false,
  refContainer: { current: null },
  setPageMenuItems: () => {},
  setToolbarReadOnly: () => {},
  pageMenuItems: [],
  headerHeight: 0,
  startLoading: () => {},
  finishLoading: () => {},
  setDisableNavDrawer: () => {},
  showToast: (_toast: React.ComponentProps<typeof Toast>) => {},
  clearToasts: () => {},
});
